<div class="future-equipment-form">
  <div class="section-header">
    {{ 'Future equipment' | translate }}
  </div>

  <div class="form-group">
    <div class="form-field">
      <label>
        {{ 'Asset label' | translate }}
        <span class="future-suffix">{{ '(future equipment)' | translate }}</span>
      </label>
      <input
        nbInput
        fullWidth
        [(ngModel)]="baseLabel"
        placeholder="-"
        [disabled]="readOnly"
      />
    </div>

    <div
      (click)="toggleDetails()"
      style="display: flex; justify-content: center; padding: 4px 0; background-color: #f0f0f0; color: #000; font-size: 12px; cursor: pointer; user-select: none;"
    >
      {{ showDetails ? '(-)' : '(+)' }} {{ 'Detail' | translate }}
    </div>

    @if (showDetails) {
      <div class="form-field" [class.display-with-link]="!readOnly" (click)="openAssetTypePanel()">
        <label>{{ 'Asset type' | translate }}</label>
        <div>
          <span>{{ currentAssetTypeName }}</span>
          @if (!readOnly) {
            <span class="right-chevron"><i class="far fa-chevron-right fal"></i></span>
          }
        </div>
      </div>

      <div class="form-field">
        <label>{{ 'Quantity' | translate }}</label>
        <input
          nbInput
          fullWidth
          type="number"
          [(ngModel)]="quantity"
          placeholder="-"
          min="0"
          [disabled]="readOnly"
        />
      </div>


      <div class="form-field">
        <label>{{ 'Zone details' | translate }}</label>
        <input
          nbInput
          fullWidth
          [(ngModel)]="zoneDetails"
          placeholder="-"
          [disabled]="readOnly"
        />
      </div>

      <div class="form-field">
        <label>{{ 'Comments' | translate }}</label>
        <textarea
          nbInput
          fullWidth
          [(ngModel)]="comments"
          placeholder="-"
          rows="3"
          [disabled]="readOnly"
        ></textarea>
      </div>
    }
  </div>

</div>
